export default "__VITE_ASSET__C$O6hE03__"